module.exports = __webpack_public_path__ + "static/img/g_2.b3a37550.png";